function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Power_plant"
}, /*#__PURE__*/React.createElement("title", null, "VF_power_plant_rgb"), /*#__PURE__*/React.createElement("path", {
  d: "M255 168.6V106h-70.8V63.8H28.5v76.8L4.7 283.5h275L255 168.6zM38.1 255.1l18.7-112.2V92.1h99.1v50.8l18.7 112.2H38.1zm165.2 0l-19.1-114.6v-6.2h42.5v37.2l17.9 83.5h-41.3zM82.3 42.5L95 48.9l8.6-17.4-7.1-14.2 5.5-11L89.4 0l-8.7 17.3 7.1 14.2zM117.7 42.5l12.7 6.4 8.6-17.4-7.1-14.2 5.5-11L124.8 0l-8.7 17.3 7.1 14.2z"
}))));